<template>
  <span
    :class="{
      [$style.grayContainer]: isExpiringLater || noBackground,
      [$style.redContainer]: isExpired && !noBackground,
      [$style.yellowContainer]: isExpiringSoon && !noBackground,
    }"
  >
    {{ expiryDateDisplay }}
  </span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MdmCertificateStatus',

  props: {
    expiresOnDate: {
      default: '',
      type: String,
    },
    noBackground: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    expiryDate() {
      return moment.utc(this.expiresOnDate).diff(moment().utc(), 'days', true);
    },

    expiryDateDisplay() {
      let message = '';

      if (this.isExpiringLater || this.isExpiringSoon) {
        message = `Expires ${moment.utc(this.expiresOnDate).format('LLL')} (UTC)`;
      }

      if (this.isExpired) {
        message = 'Expired';
      }

      return message;
    },

    isExpired() {
      return this.expiryDate <= 0;
    },

    isExpiringLater() {
      return this.expiryDate > 60;
    },

    isExpiringSoon() {
      return this.expiryDate > 0 && this.expiryDate <= 60;
    },
  },
};
</script>

<style module>
@value (jcError100, jcWarning100) from '~css/brand-colors.css';

.container {
  border-radius: 6px;
  line-height: 1rem;
  padding: 3px 9px;
  width: fit-content;
}

.redContainer {
  composes: container;
  background-color: jcError100;
}

.yellowContainer {
  composes: container;
  background-color: jcWarning100;
}

.grayContainer {
  line-height: 1rem;
  padding: 0.4em 0;
  width: fit-content;
}
</style>
